/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heading_Reads_PrefixInputs */

const en_heading_reads_prefix = /** @type {(inputs: Heading_Reads_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Similar`)
};

const ar_heading_reads_prefix = /** @type {(inputs: Heading_Reads_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قراءات`)
};

const bn_heading_reads_prefix = /** @type {(inputs: Heading_Reads_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আরও`)
};

const de_heading_reads_prefix = /** @type {(inputs: Heading_Reads_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ähnliche`)
};

const es_heading_reads_prefix = /** @type {(inputs: Heading_Reads_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecturas`)
};

const fr_heading_reads_prefix = /** @type {(inputs: Heading_Reads_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lectures`)
};

const pt_heading_reads_prefix = /** @type {(inputs: Heading_Reads_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leituras`)
};

const zh_heading_reads_prefix = /** @type {(inputs: Heading_Reads_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类似`)
};

const tr_heading_reads_prefix = /** @type {(inputs: Heading_Reads_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benzer`)
};

const ru_heading_reads_prefix = /** @type {(inputs: Heading_Reads_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Похожие`)
};

const pl_heading_reads_prefix = /** @type {(inputs: Heading_Reads_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podobne`)
};

/**
* | output |
* | --- |
* | "Similar" |
*
* @param {Heading_Reads_PrefixInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const heading_reads_prefix = /** @type {((inputs?: Heading_Reads_PrefixInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heading_Reads_PrefixInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_heading_reads_prefix(inputs)
	if (locale === "bn") return bn_heading_reads_prefix(inputs)
	if (locale === "de") return de_heading_reads_prefix(inputs)
	if (locale === "es") return es_heading_reads_prefix(inputs)
	if (locale === "fr") return fr_heading_reads_prefix(inputs)
	if (locale === "pt") return pt_heading_reads_prefix(inputs)
	if (locale === "zh") return zh_heading_reads_prefix(inputs)
	if (locale === "tr") return tr_heading_reads_prefix(inputs)
	if (locale === "ru") return ru_heading_reads_prefix(inputs)
	if (locale === "pl") return pl_heading_reads_prefix(inputs)
	return en_heading_reads_prefix(inputs)
});